import type { FaireProductEntity } from "../../entity_types/product";

export const p_9tg9byww7r: FaireProductEntity = {
  token: "p_9tg9byww7r",
  type: "product",
  name: "Wax Bottles",
  brandToken: "b_7p5vnswqfb",
  brandName: "MEGASNAX",
  imageUrl:
    "https://cdn.faire.com/fastly/80e10b51bf1c58c050e9dce969247f3f3f5496b6f870a8668676546d9bb78754.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/660c149450a4bcad3ecf85b12a6dd94282b8045715ee449b019b279ca649f704.png",
  ],
  priceDollars: 2.31,
  description:
    'Wax bottles, most famously known by the brand name MegaSnax, are a nostalgic novelty candy consisting of small, bottle-shaped containers made from food-grade paraffin wax and filled with flavored fruit syrup. \n\nHow to Eat Them\nThe traditional method of consumption involves three steps:\nBite: Biting off the "cap" or top of the wax bottle.\nSip: Sucking or squeezing out the sweet liquid syrup inside.\nChew: Chewing the remaining wax like bubblegum to extract any leftover flavor. \nSafety Note: While the wax is non-toxic and food-grade, it is intended to be chewed and spit out, not swallowed. \n\nFlavor and Texture Profile\n\nSyrup: The liquid center is a sugary, somewhat sticky syrup. Common flavors include Cherry, Orange, Lemon, Lime, Blue Raspberry, and Green Apple.\n\nWax: The exterior has a firm, waxy texture that is translucent.\n\nAlternative Methods: Some enthusiasts recommend freezing the bottles for about 10 minutes to create a "satisfying crunch" when biting into the wax',
  tags: [],
  msrpDollars: 4.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:10.246Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
